'use client';

import React, { Fragment } from 'react';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import classNames from 'classnames';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/16/solid';
import { getBackgroundProp, resolveSetting } from '../../../utils/settingsHelper';

export const getNavbarStyle = (props, settings) => ({
	background: getBackgroundProp(props, settings),
	color: resolveSetting(props.color, settings),
});
export function Navbar({ logo, items, right, settings, showMobileMenu = true, center, ...props }) {
	return (
		<Disclosure as="nav" style={getNavbarStyle(props, settings)}>
			{({ open }) => (
				<>
					<div className="px-2 @md:px-6 @lg:px-8 py-4">
						<div className="relative flex items-center justify-between">
							{showMobileMenu && (
								<div className="inset-y-0 left-0 flex items-center @md:hidden">
									{/* Mobile menu button */}
									<DisclosureButton
										style={{ color: resolveSetting(props.color, settings) }}
										className="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
									>
										<span className="absolute -inset-0.5" />
										<span className="sr-only">Open main menu</span>
										{open ? (
											<XMarkIcon className="block h-6 w-6" />
										) : (
											<Bars3Icon className="block h-6 w-6" />
										)}
									</DisclosureButton>
								</div>
							)}
							<div className="flex flex-1 items-center justify-center @md:justify-start">
								<div className="flex flex-shrink-0 items-center">
									{logo}
								</div>
								<div className={classNames('hidden @sm:block', { 'mx-auto': center })}>
									{items}
								</div>
							</div>
							<div className="hidden absolute inset-y-0 right-0 @md:flex items-center pr-2 @md:static @md:inset-auto @md:ml-6 @md:pr-0">
								{right}
							</div>
						</div>
					</div>

					<DisclosurePanel className="@md:hidden">
						<div className="space-y-1 px-2 pb-3 pt-2">
							{items}
							{right}
						</div>
					</DisclosurePanel>
				</>
			)}
		</Disclosure>
	);
}
